import Box from '@mui/material/Box';
import FormControl, { FormControlProps } from '@mui/material/FormControl';
import { FC, PropsWithChildren } from 'react';
import { ISupportedInputTypes } from './FieldTypes';
import { getSxValue, isFullWidth } from './utils';

type IProps = PropsWithChildren<
    Pick<FormControlProps, 'error' | 'sx'> & {
        type: ISupportedInputTypes;
        fullWidth: boolean;
        hidden: boolean;
        width?: number;
        noWrap?: boolean;
        widthByContent?: boolean;
    }
>;

const FieldWrapper: FC<IProps> = ({
    children,
    type,
    fullWidth,
    hidden,
    sx,
    width = 12,
    noWrap = false,
    widthByContent = false,
    ...rest
}) =>
    type === 'multiRowInputs' ? (
        <div style={{ ...(hidden ? { display: 'none' } : {}), width: '100%' }}>{children}</div>
    ) : type === 'html' ? (
        <Box
            {...rest}
            sx={{
                boxSizing: 'border-box',
                ...(widthByContent ? {} : getSxValue(width)),
                ...sx,
                ...(hidden ? { display: 'none' } : {})
            }}
        >
            {children}
        </Box>
    ) : (
        <FormControl
            {...rest}
            variant="outlined"
            sx={{
                boxSizing: 'border-box',
                ...sx,
                ...(widthByContent ? {} : getSxValue(width)),
                ...(hidden ? { display: 'none' } : {}),
                ...(!noWrap ? { marginBottom: 0 } : {})
            }}
            fullWidth={isFullWidth(fullWidth, {
                type,
                props: { fullWidth, name: '', sx }
            })}
        >
            {children}
        </FormControl>
    );

export default FieldWrapper;
